export default __webpack_public_path__ + "static/media/coresanscr15it-webfont.09ff6441.woff2";